import { FC } from 'react';

import { Button } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

import { AdfoxCtaButtonStyle } from 'components/Admin/AdfoxInfo/adfoxInfoModel';

import styles from 'components/Admin/AdfoxInfo/PromoFields/FullScreenStyleFields/preview.module.less';

const TrlKeys = {
    button: 'admin.adfoxInfo.preview.button',
};

const CTA_BUTTON_PREVIEW: Record<AdfoxCtaButtonStyle, { style: 'accent' | 'constant' | 'neutral'; isDark: boolean }> = {
    [AdfoxCtaButtonStyle.Accent]: { style: 'accent', isDark: false },
    [AdfoxCtaButtonStyle.Contrast]: { style: 'constant', isDark: true },
    [AdfoxCtaButtonStyle.Neutral]: { style: 'neutral', isDark: false },
};

interface CtaButtonPreviewProps {
    option: AdfoxCtaButtonStyle;
}

export const CtaButtonPreview: FC<CtaButtonPreviewProps> = ({ option }) => {
    const trls = useTrls();
    const { style, isDark } = CTA_BUTTON_PREVIEW[option];

    return (
        <div
            className={isDark ? styles.previewDark : styles.previewLight}
            data-qa={`adfox-info-cta-style-preview-${option}`}
        >
            <Button mode="primary" style={style} size="small">
                {trls(TrlKeys.button)}
            </Button>
        </div>
    );
};
